import { useFeatureFlags } from '@usap/core'
import { getVariationValue } from "@usap/carparts/scripts/utils"

export const usef32flag = (decisions): boolean => {
    const decision = decisions?.f32 || "false";
    return getVariationValue(decision as string);
};


export const usef32flagCSR = (): boolean => {
    const decisions = useFeatureFlags()
    return usef32flag(decisions);
};

export const usef40flag = (decisions): boolean => {
    const f40 = decisions?.f40 || "false"
    return getVariationValue(f40)
}